import { http } from '@pendo/http';
import { v4 as uuid } from 'uuid';
import has from 'lodash/has';

export const MAX_RETRIES = 5;

export const aggregationsEndpoint = '/api/aggregation/s/_SID_/?all=true';

// workaround to allow aggs to run to completion instead of using agg-connect
// used for fetchPageLoadEvents for suggested pages
// code taken from via
export async function request (spec, { rowsOnly = true, signal, location = 'request', name } = {}) {
    spec.requestId = uuid();
    const payload = {
        requests: [spec],
        response: {
            name,
            location,
            mimeType: 'application/json',
        },
    };

    const axiosConfig = { retry: MAX_RETRIES };
    if (signal) axiosConfig.signal = signal;

    const { data } = await http.post(`${aggregationsEndpoint}&name=${spec.name}`, payload, axiosConfig);

    if (data && data.aggregationJobId) {
        // this is a long-running aggregation
        return data;
    }
    // when response exceeds a certain size, backend stores it in GCS
    const gcsUrlPromises = [];
    const messagesHasUrl = data.messages.some((message) => message.url);
    if (messagesHasUrl) {
        for (const message of data.messages) {
            if (has(message, 'url')) {
                gcsUrlPromises.push(http.get(message.url, { withCredentials: false }));
            } else {
                gcsUrlPromises.push({ data: message.rows });
            }
        }
        const responses = await Promise.all(gcsUrlPromises);
        for (const message of data.messages) {
            const { data } = responses.shift();
            message.rows = data;
        }
    }

    return rowsOnly ? data.messages[0].rows : data;
}
